import React from "react";
import { Space, Typography } from "antd";

const { Text } = Typography;

/*
 * The visual before / after convention of every table of the wizard (see ../merge.scss):
 * « Avant » columns light grey, « Après » columns light green, « Action » columns light blue.
 * Spread `BEFORE_COL` / `AFTER_COL` / `ACTION_COL` into an antd column definition — header
 * AND body cells get the class name.
 */

const col = className => ({
  className,
  onHeaderCell: () => ({ className }),
  onCell: () => ({ className }),
});

export const BEFORE_COL = col("merge-col-before");
export const AFTER_COL = col("merge-col-after");
export const ACTION_COL = col("merge-col-action");

/** Class of one body cell: the column tint plus, when `differs`, the « this value is not the same everywhere » tint. */
export const cellClass = (base, differs) =>
  differs ? `${base} merge-cell-differs` : base;

/** A before-value that the merge replaces: struck through and greyed; otherwise plain. */
export function BeforeValue({ changes, children }) {
  return changes ? (
    <Text delete type="secondary">
      {children}
    </Text>
  ) : (
    <>{children}</>
  );
}

/** An after-value: bold — it is what the operator gets. */
export function AfterValue({ children }) {
  return <Text strong>{children}</Text>;
}

/** The colour legend, shown once above a step's tables. */
export function BeforeAfterLegend({ action = true }) {
  return (
    <Space size={12} wrap className="merge-legend">
      <span>
        <span className="merge-legend-swatch merge-col-before" /> Avant
        (aujourd'hui)
      </span>
      <span>
        <span className="merge-legend-swatch merge-col-after" /> Après (résultat
        de la fusion)
      </span>
      {action && (
        <span>
          <span className="merge-legend-swatch merge-col-action" /> Action /
          décision
        </span>
      )}
    </Space>
  );
}
